import React from 'react';
import { Button } from 'src/shared/ui/buttons/button';
import { CountdownSpinner } from './countdown-spinner';
import { usePlayerContext } from '../../context/player-context';

interface EndScreenProps {
  isLastVideo?: boolean;
}

export const EndScreen: React.FC<EndScreenProps> = ({ isLastVideo = false }) => {
  const { showEndScreen, countdown, handleRestart, handleNextVideo } = usePlayerContext();

  if (!showEndScreen) {
    return null;
  }

  return (
    <div className="absolute inset-0 z-30 flex flex-col items-center justify-center bg-black bg-opacity-75">
      <Button
        onClick={(e) => {
          e.stopPropagation();
          handleRestart();
        }}
        className="mb-4"
      >
        Riavvia Video
      </Button>

      {!isLastVideo && (
        <Button
          onClick={(e) => {
            e.stopPropagation();
            handleNextVideo();
          }}
          className="flex items-center"
        >
          Prossimo Video
          {countdown !== null && <CountdownSpinner countdown={countdown} />}
        </Button>
      )}
    </div>
  );
};
